
import { useMemo } from 'react'
import TablePopup from 'src/component/popup/TablePopup'
import { GetPatientHistory } from 'src/requests/PatientMedicalHistory'

const MedicalNotesHistoryPopup = ({ id, modalId }: { id: number|null, modalId: any }) => {

    const columns = useMemo(() => [
        {
            Header: "diseaseName",
            accessor: "diseaseName",
        },
        {
            Header: "notes",
            accessor: "notes",
        },
        {
            Header: "createdAt",
            accessor: "createdAt",
        },
        {
            Header: "byUserName",
            accessor: "byUserName",
        }
    ], [])

    return (
        <TablePopup
            fetchId={id}
            apiFunc={GetPatientHistory}
            columns={columns}
            refModal={modalId}
            onClosePopup={() => modalId.current.click()}
            title={"medical-history"} />
    )
}

export default MedicalNotesHistoryPopup